import { gql } from '@apollo/client/core';

const LOGIN_MUTATION = gql`
  mutation loginMutation($input: Input, $path: string) {
    login(input: $input, path: $path)
      @rest(path: "{args.path}", method: "POST") {
      succesvol
      redirectTo
      redirectUrl
      algemeneVoorwaardenNietAkkoord
      emailadres
      telefoonnummer
      qrCode
      methodeOmTeVerifieren
      tweeStapsVerificatieMethoden {
        disabled
        selected
        text
        key
        value
      }
      verstuurdeMethode
      emailadres
      telefoonnummer
      verwerkersovereenkomstOrganisatieNaam
      verwerkersovereenkomstKlantteamTelefoonnummer
      emailNeedsConfirmation
      phonenumberNeedsConfirmation
      showPopup
      popup {
        title
        message
      }
      loginMessage {
        title
        message
      }
      knownError {
        description
        key
      }
    }
  }
`;

export default LOGIN_MUTATION;
